import { type FC } from 'react';
import cn from 'classnames';

import { selectMyTicketsByType } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { useCurrentLotteryTier } from '../../hooks';
import { TicketList } from '../TicketList/TicketList';

interface MyTicketListProps {
  isOpen: boolean;
  className?: string;
}

const MyTicketList: FC<MyTicketListProps> = ({ isOpen, className }) => {
  const currentTier = useCurrentLotteryTier();
  const list = useAppSelector((state) =>
    selectMyTicketsByType(state, currentTier),
  );

  return (
    <TicketList
      initial={{ height: 0 }}
      animate={{ height: isOpen ? 'auto' : 0 }}
      className={cn(className, 'max-h-[50vh]')}
      ticketType={currentTier}
      list={list}
    />
  );
};

export { MyTicketList };
